<template>
  <div class="sales">
    <div class="sales-title">旗下销售</div>
    <ul class="sales-list">
        <template v-for="(item,index) in user_arr" >
            <li  v-if="item.mobile" :key="index">
            <i class="iconfont icon-weixin1" :class="{'text-success':item.uid!=item.wechat_openid}"></i> {{item.truename}} <span>{{item.mobile}}</span>
            </li>
        </template>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'Sales',
  components: {},
  props: {
    user_arr: {
      type: Array,
      default: () => []
    },
    type:{
      type:Number,
      default:0
    }
  },
  data() {
    return {
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {}
};
</script>

<style lang="scss" scoped>
    .sales{
        box-shadow: 0px 0px 7px #eee;
        background-color: #fff;
        height: 126px;
        padding: 12px 18px;
        margin-bottom: 20px;
        border-radius: 6px;
        text-align: left;
    }
    .sales-title{
        font-weight: bold;
        font-size: 16px;
    }
    .sales-list{
        display: flex;
        flex-wrap: wrap;
        margin-top: 12px;
        i{
            font-size: 14px;
            color: #999;
            margin-right: 6px;
        }
        li{
            background-color: #f5f5f5;
            padding: 4px 8px;
            margin-right: 8px;
            margin-bottom: 8px;
            border-radius: 4px;
        }
        span{
            margin-left: 6px;
        }
    }
</style>
